class Subscription {
  constructor(data) {
    this.subscribers = [];
    this.data = data;
  }

  subscribe(fn) {
    fn(this.data);
    const ind = this.subscribers.push(fn);
    return () => this.subscribers.splice(ind - 1, 1);
  }

  set(data) {
    this.data = data;
    this.subscribers.forEach((fn) => fn(_.cloneDeep(this.data)));
  }
}

class SessionService {
  constructor(
    professionalService,
    userService,
    recordService,
    $sessionStorage,
    $localStorage,
    errorHandler,
    UserTypeService
  ) {
    this.professionalService = professionalService;
    this.userService = userService;
    this.recordService = recordService;
    this.localStorage = $localStorage;
    this.sessionStorage = $sessionStorage;
    this.errorHandler = errorHandler;
    this.userTypeService = UserTypeService;
    this.professionalSubscription = new Subscription(
      this.sessionStorage["professional"]
    );
    this.notificationsSubscritpion = new Subscription(
      this.sessionStorage["notifications"]
    );
    this.consentsData = null;
  }

  setAvatar(url) {
    this.professionalSubscription.set({
      ...this.sessionStorage["professional"],
      profilePicUrl: url,
      profilePicThumbUrl: url,
    });
  }

  async updateProfessional() {
    const selectOptions = {
      select: {
        intId: 1,
        activatedAt: 1,
        affiliations: 1,
        createdAt: 1,
        firstName: 1,
        lastName: 1,
        address: 1,
        dateOfBirth: 1,
        deactivatedAt: 1,
        deactivatedBy: 1,
        deactivationNotes: 1,
        email: 1,
        emailVerifiedAt: 1,
        facebookId: 1,
        linkedInId: 1,
        gender: 1,
        emailCommunicationEnabled: 1,
        phoneNumber: 1,
        ssn: 1,
        timezone: 1,
        profilePicUrl: 1,
        profilePicThumbUrl: 1,
        languages: 1,
        "briefcase.activityWork": 1,
        "briefcase.additionalCertifications": 1,
        "briefcase.additionalDocuments": 1,
        "briefcase.certifications": 1,
        "briefcase.completedAt": 1,
        "briefcase.competencies": 1,
        "briefcase.continuingEducation": 1,
        "briefcase.currentStep": 1,
        "briefcase.driversLicense": 1,
        "briefcase.education": 1,
        "briefcase.educationDocuments": 1,
        "briefcase.educationLevel": 1,
        "briefcase.ehrSkills": 1,
        "briefcase.facilities": 1,
        "briefcase.healthDocuments": 1,
        "briefcase.liabilityInsurance": 1,
        "briefcase.licensedAt": 1,
        "briefcase.licenses": 1,
        "briefcase.licenseHistory": 1,
        "briefcase.nursys": 1,
        "briefcase.organizationMembership": 1,
        "briefcase.personalStatement": 1,
        "briefcase.references": 1,
        "briefcase.skillsChecklists": 1,
        "briefcase.specialties": 1,
        "briefcase.summary": 1,
        "briefcase.vehicleInsurance": 1,
        "briefcase.w9": 1,
        "briefcase.workExperience": 1,
        "briefcase.yearsOfExperience": 1,
        emergencyContact: 1,
        isMarketplace: 1,
        "jobs.cancelledJobs": 1,
        "jobs.confirmedJobs": 1,
        "jobs.competentReviews": 1,
        "jobs.professionalReviews": 1,
        "jobs.skilledReviews": 1,
        "jobs.badgedReviews": 1,
        "jobs.newJobEmail": 1,
        "jobs.newJobSms": 1,
        "jobs.workCities": 1,
        "jobs.workStates": 1,
        "jobs.workDistance": 1,
        "jobs.availiableDate": 1,
        "jobs.requestedTimeOff": 1,
        "jobs.preferredShift": 1,
        "jobs.preferredSchedule": 1,
        profession: 1,
        suspendedAt: 1,
        userType: 1,
      },
    };
    const [data, records] = await Promise.all([
      this.professionalService.get(this.localStorage["token"], selectOptions),
      this.consentsData
        ? this.consentsData
        : this.recordService.list({
            auth: this.localStorage["token"],
            recordTypes: [RecordsClient.StandardRecordType.Consent],
            returnData: true,
          }),
    ]);
    const userType = _.get(data, "userType", null);

    if (userType !== this.userTypeService.Nurse) {
      this.localStorage.$reset();
      this.errorHandler.stop();
      throw new Error("You are not authorized to access this site.");
    }

    data["consents"] = records.list;
    this.consentsData = { count: records.count, list: records.list };

    this.localStorage["userType"] = userType;
    this.localStorage["userId"] = _.get(data, "_id", null);

    const affiliations = _.get(data, "affiliations", []);
    const key = _.get(data, "affiliations[0].organization.coBrandedUrl");
    if (affiliations.length === 1 && key) {
      this.localStorage["coBrandedKEY"] = key;
    } else {
      this.localStorage["coBrandedKEY"] = undefined;
    }
    this.professionalSubscription.set(data);
    this.sessionStorage["professional"] = data;
  }

  async updateNotifications() {
    const data = await this.userService.listNotifications(
      this.localStorage["token"]
    );
    this.notificationsSubscritpion.set(data);
    this.sessionStorage["notifications"] = data;
  }

  get professionalData() {
    return this.professionalSubscription;
  }

  get notifications() {
    return this.notificationsSubscritpion;
  }
}

(function () {
  function sessionService(ps, us, rs, ss, ls, eh, ut) {
    return new SessionService(ps, us, rs, ss, ls, eh, ut);
  }

  angular
    .module("myApp")
    .factory("sessionService", [
      "ProfessionalService",
      "userService",
      "RecordService",
      "$sessionStorage",
      "$localStorage",
      "errorHandler",
      "UserTypeService",
      sessionService,
    ]);
})();
